






































import { Vue, Component } from 'vue-property-decorator'
import Arrows from '@/components/Arrows.vue'
import { getBlogPosts } from '@/services/cms'

@Component({
  metaInfo: {
    title: 'Blog',
  },
  components: {
    Arrows
  },
})
export default class Blog extends Vue {
  
  loadingPosts = true

  async mounted() {
    this.loadingPosts = true
    await getBlogPosts(this.$store)
    this.loadingPosts = false
    console.log(this.posts)
  }

  get posts() {
    return this.$store.getters.blogPosts.sort((a: any, b: any) => {
      return (new Date(b.attributes.createdAt).getTime() - new Date(a.attributes.createdAt).getTime())
    })
  }

}
